import { status } from 'skin/event/status';
import { message } from 'skin/event';

const click = (obj, ms, story, data, d, action) => {
    console.log('[Ячейки - Мастер] событие', obj);
    const fld = data.curData.values.fld
    if (!fld.prop) {
        message('Выберите свойство', 'Ячейки')
		return status.ignore
    }
    const row = {
        key: fld.prop,
        name: fld.prop,
        list: [fld.txtProp]
    }
    const table = data.curData.values.table.property

    const i = table.list.findIndex(el => el.key === fld.prop)
    if (i === -1) data.addRow(ms, 'property', row)
    else {
        const a = [...table.list]
        a[i] = row
        table.list = a
    }
    table.list = table.list.sort((a, b) => {
        if (a.list[0] < b.list[0]) return -1
        return 1
    })
    data.setValue('prop', '')
    data.setValue('txtProp', '')
	return status.action
}

export default click